<script setup lang="ts">
/**
 * Bandeau « Paiement sécurisé par Stripe et PayPal, certifiés PCI-DSS
 * niveau 1 » + badges CB / VISA / Mastercard. Partagé entre /a/[slug] et
 * /b/[slug].
 *
 * Plus de badge « PCI DSS » seul (31/10/2026) : il laissait croire que Donoor
 * lui-même était certifié. La certification est celle de Stripe et PayPal.
 */
</script>

<template>
  <div class="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 py-3">
    <div class="flex items-center gap-1.5 text-[#717198] dark:text-gray-500">
      <UIcon name="i-lucide-lock" class="size-3.5" />
      <span class="text-xs md:text-sm font-medium">{{ $t("association.publicPage.paiementSecurise") }}</span>
    </div>
    <div class="flex items-center gap-1.5">
      <div class="h-6 md:h-7 px-2 rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 flex items-center justify-center">
        <span class="text-[10px] font-bold text-[#1a1f71]">CB</span>
      </div>
      <div class="h-6 md:h-7 px-2 rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 flex items-center justify-center">
        <span class="text-[10px] font-bold text-[#1a1f71]">VISA</span>
      </div>
      <div class="h-6 md:h-7 px-2 rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 flex items-center justify-center">
        <span class="text-[10px] font-bold text-[#eb001b]">&#9679;</span><span class="text-[10px] font-bold text-[#f79e1b] -ml-1">&#9679;</span>
      </div>
    </div>
  </div>
</template>
